// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"8a8f77e5","453":"cca6e84a"}[chunkId] + ".chunk.js";
};